import React from "react";

export default function FormLabel({ htmlFor, className, children }) {
  return (
    <label htmlFor={htmlFor} className={className}>
      {children}
    </label>
  );
}
